import { render } from "./TransferSubAgentOperationExecutiveView.vue?vue&type=template&id=0366b7b2"
import script from "./TransferSubAgentOperationExecutiveView.vue?vue&type=script&lang=js"
export * from "./TransferSubAgentOperationExecutiveView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__